<template>
  <v-app>
    <v-app-bar app flat color="white">
      <FullHeaderComponent />
    </v-app-bar>
    <v-main class="grey lighten-4 pt-14">
      <div class="container1400">
        <v-container fluid>
          <div class="mt-6">
            <v-skeleton-loader v-if="!list" type="article"></v-skeleton-loader>
            <v-alert dense outlined type="error" v-if="error">
              <ul>
                <li v-for="item in error" :key="item.msg">
                  {{ $t(item.msg) }}
                </li>
              </ul>
            </v-alert>
            <div v-if="list">
              <div class="pt-5">
                <h1 class="text-h4 font-weight-medium">{{ list.name }}</h1>
                <div class="subtitle-1 pt-3 text-capitalize">
                  <span>
                    <v-icon small color="light-blue"
                      >mdi-map-marker-radius</v-icon
                    >
                    {{ list.address.city }}
                    <span v-if="list.address.statesprovinces"
                      >, {{ list.address.statesprovinces }}</span
                    >
                    , {{ list.address.country }}
                  </span>
                </div>
                <div
                  v-if="list.no_rooms"
                  class="subtitle-1 pt-3 text-capitalize font-weight-regular grey--text text--darken-4"
                >
                  <v-avatar class="mr-2" color="light-blue" size="24">
                    <span class="white--text subtitle-2">{{
                      list.no_rooms
                    }}</span> </v-avatar
                  >{{ $tc("Room", 2) }}
                </div>
              </div>
              <v-row>
                <v-col cols="12" md="8">
                  <v-sheet
                    color="light-blue"
                    height="480px"
                    v-if="!list.pictures.length"
                  >
                    <v-row class="fill-height" align="center" justify="center">
                      <div class="display-3">NO Images</div>
                    </v-row>
                  </v-sheet>
                  <v-carousel
                    hide-delimiters
                    class="mt-5 mb-5"
                    height="480"
                    v-else
                  >
                    <v-carousel-item
                      v-for="(item, i) in list.pictures"
                      :key="i"
                      :src="
                        $store.state.baseUrl +
                          'listing/non-partner/thumb800x480-' +
                          item.file_name
                      "
                    >
                    </v-carousel-item>
                  </v-carousel>
                  <div class="body-2 pt-3" v-html="list.description">
                    {{ list.description }}
                  </div>
                </v-col>
                <v-col md="4" cols="12">
                  <v-card
                    v-if="fresh"
                    elevation="1"
                    class="ml-md-5 mt-5 mx-auto"
                  >
                    <v-card-title class="pa-4 light-blue white--text">
                      {{ $t("s1660136745") }}
                    </v-card-title>
                    <v-card-text class="pa-4">
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-alert dense outlined type="info">
                          {{ $t("s1660149392") }}
                        </v-alert>
                        <v-row>
                          <v-col cols="12">
                            <v-text-field
                              type="text"
                              outlined
                              v-model="data.firstName"
                              :rules="reqRules"
                              v-bind:label="$t('FirstName')"
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              outlined
                              type="text"
                              v-model="data.lastName"
                              v-bind:label="$t('LastName')"
                              :rules="reqRules"
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <v-text-field
                              outlined
                              type="email"
                              v-model="data.email"
                              v-bind:label="$t('EmailAddress')"
                              :rules="emailRules"
                              hide-details="auto"
                            ></v-text-field>
                          </v-col>
                          <v-col cols="12">
                            <vue-tel-input-vuetify
                              outlined
                              v-bind:label="$t('PhoneNumber')"
                              :rules="phoneRules"
                              v-model="data.phone"
                              aria-autocomplete=""
                              placeholder=""
                              mode="international"
                              defaultCountry="US"
                              :preferredCountries="['US', 'JP']"
                              hide-details="auto"
                            ></vue-tel-input-vuetify>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" class="pt-5 text-center">
                            <v-btn
                              large
                              block
                              color="light-blue"
                              dark
                              @click="sendDetails"
                            >
                              <span class="mr-2">{{
                                $t("ClickToSubmit")
                              }}</span>
                              <v-icon size="small"
                                >mdi-arrow-right-thick</v-icon
                              >
                            </v-btn>
                          </v-col>
                        </v-row>
                      </v-form>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
            </div>
          </div>
        </v-container>
      </div>
    </v-main>
    <v-footer app>
      <CopyrightComponent />
    </v-footer>
  </v-app>
</template>

<script>
// @ is an alias to /src
import FullHeaderComponent from "@/components/layout/FullHeaderComponent.vue";
import CopyrightComponent from "@/components/layout/CopyrightComponent.vue";
import ListingService from "@/services/ListingService";
import { format } from "date-fns";
import swal from "sweetalert";

export default {
  name: "GuestViewNPListing",
  components: {
    FullHeaderComponent,
    CopyrightComponent
  },
  data() {
    return {
      format,
      list: null,
      data: {},
      fresh: true,
      valid: null,
      parm: this.$route.params.id,
      error: null,
      reqRules: [value => !!value || this.$t("string719")],
      emailRules: [
        value => !!value || this.$t("string719"),
        value => {
          const pattern = /^(([^<>()[\]\\.,;:+\s@"]+(\.[^<>()[\]\\.,;:+\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || this.$t("string724");
        }
      ]
    };
  },
  computed: {
    phoneRules() {
      const rules = [];
      if (this.data.phone) {
        const rule1 = value => {
          const pattern = /[A-Za-z]+/;
          return !pattern.test(value) || this.$t("string722");
        };
        const rule2 = value =>
          (value.length >= 7 && value.length <= 18) || this.$t("string723");
        rules.push(rule1, rule2);
      }
      return rules;
    }
  },
  created: function() {
    ListingService.guestViewNPProperty({
      id: this.parm
    })
      .then(result => {
        this.list = result.data;
      })
      .catch(err => {
        this.error = err.response.data.error;
      });
  },
  methods: {
    async sendDetails() {
      await this.$refs.form.validate();
      if (this.valid) {
        this.waitDialog = true;
        this.data.property_id = this.parm;
        await ListingService.contactOwner(this.data)
          .then(() => {
            this.waitDialog = false;
            this.fresh = false;
            swal({
              icon: "success",
              text: this.$t("s1660149381"),
              button: {
                text: this.$t("Close"),
                className: "swal-close"
              }
            });
          })
          .catch(err => {
            this.waitDialog = false;
            this.error = err.response.data.errors;
          });
      }
    }
  }
};
</script>

<style></style>
